require('./radioButtonTableFunds.scss');

const PropTypes = require('prop-types');

const React = require('react');


// @commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { RadioButton } = require('commonsComponents/radioButton');

//@helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatWithoutRound } = require('utilities/currencyHelper');


class RadioButtonTableFunds extends React.Component {
    constructor(props) {
        super(props);
        this.handleProductSelect = this.handleProductSelect.bind(this);
    }

    buildAmountCurrencyEur(amount, currency) {
        return (
            <span className="broker-products-table-row__second-row-eur">
                <span className="broker-products-table-row__amount-eur">{amount}</span>
                <span className="broker-products-table-row__currency-eur">{currency}</span>
            </span>
        );
    }

    buildProfitability(amountCurrency, percentage) {
        return (
            <div className="broker-products-table-row__earnings-row">
                {amountCurrency}
                <span className="broker-products-table-row__earnings-separator">|</span>
                <span className="broker-products-table-row__earnings-percentage">
                    {percentage}%
                </span>
            </div>
        );
    }

    buildProfitabilityEurLabelFor(immStock) {
        const profitabilityEur = immStock.getIn(['earningsEur', 'amount']);
        const investmentEur = immStock.getIn(['investmentEur', 'amount']);

        if (profitabilityEur == null || investmentEur == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials"/>;
        }

        const percentageEur = immStock.get('profitablePercentageEuros');
        const currencyEur = immStock.getIn(['earningsEur','currency']);

        const profitabilityPercentage = formatWithoutRound(percentageEur, 2);
        const profitabilityFormatted = formatWithoutRound(profitabilityEur, 2);
        const amountCurrencyEur = this.buildAmountCurrencyEur(profitabilityFormatted, currencyEur);
        return this.buildProfitability(amountCurrencyEur, profitabilityPercentage);
    }

    buildRowForExternalFunds(item){
        const { currentFundId } = this.props;

        const isin = item.get('isin');
        const fundName = item.get('name');
        const contractNumber = item.get('contractNumber');
        const nameElement = fundName;

        const formattedEarningsEur = this.buildProfitabilityEurLabelFor(item);
        const valueEur = formatWithoutRound(item.getIn(['totalValueEur','amount']), 2);
        const valueCurrencyEur = item.getIn(['totalValueEur','currency']);
        const formattedValueEur = this.buildAmountCurrencyEur(valueEur, valueCurrencyEur);
        const isinSection = `${formatText('broker-searchResultsIsin')}: ${isin}`;
        const contractNumberSection = `${formatText('brokerExternalTransferFundStep2-contractNumberLabel')}${contractNumber}`
        const isActive = item.get('id') === currentFundId;
        return(
            <OKTableRow>
                <OKTableCell>
                    <RadioButton
                        className="broker-search-results__radio"
                        onChange={this.handleProductSelect}
                        isChecked={isActive}
                        id={item.get('id')}
                        name={item.get('id')}
                        value={item.get('id')}
                        />
                </OKTableCell>
                <OKTableCell onClick={() => this.handleProductSelect(item.get('id'))} className="broker-search-results__table-cell">
                    <div className="broker-search-results__table-cell--bold">{nameElement}</div>
                    <div className="broker-search-results__isin-section">{isinSection}</div>
                    <div className="broker-search-results__isin-section">{contractNumberSection}</div>
                </OKTableCell>
                <OKTableCell className="broker-search-results__table-cell--capitalize" alignment="center">
                    {formattedEarningsEur}
                </OKTableCell>
                <OKTableCell className="broker-search-results__table-cell--capitalize" alignment="center">
                    {formattedValueEur}
                </OKTableCell>
            </OKTableRow>
        )
    }

    radioTableRows(results) {
        const tableRows = results.map((result) => {
            return this.buildRowForExternalFunds(result);
        });
        return tableRows;
    }

    tableHeadersForExternalFunds() {
        const PREFIX = 'broker-radioButtonTableFunds';
        const fundLabel = formatText(`${PREFIX}FundLabel`);
        const rentabilityLabel = formatText(`${PREFIX}RentabilityLabel`);
        const actualValueLabel = formatText(`${PREFIX}ActualValueLabel`);
        return(
            <OKTableRow asHeader={true} className="broker-search-results__table-header">
                <OKTableCell asHeader={true} className="broker-search-results__table-header-cell--radio" />
                <OKTableCell asHeader={true} className="broker-search-results__table-header-cell--fund-name">
                    {fundLabel}
                </OKTableCell>
                <OKTableCell asHeader={true} width="25%" alignment="center">
                    {rentabilityLabel}
                </OKTableCell>
                <OKTableCell asHeader={true} width="25%" alignment="center">
                    {actualValueLabel}
                </OKTableCell>
            </OKTableRow>
        );
    }

    handleProductSelect(id) {
        this.props.onFundChange(id);
    }


    render() {
        const { immFunds } = this.props;

        const tableHeaders = this.tableHeadersForExternalFunds();
        const tableRows =   this.radioTableRows(immFunds);
        return (
            <React.Fragment>
                <div  className="broker-search-results__table-wrapper radio-button-table-funds__container">
                    <OKTable className="broker-search-results__funds-table">
                        <thead>
                            {tableHeaders}
                        </thead>
                        <tbody>
                            {tableRows}
                        </tbody>
                    </OKTable>
                </div>
            </React.Fragment>
        );
    }
}

RadioButtonTableFunds.propTypes = {
    currentFundId: PropTypes.string.isRequired,
    onFundChange: PropTypes.func.isRequired,
    immFunds: PropTypes.object.isRequired,
};

module.exports = RadioButtonTableFunds;
